import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import moment from 'moment';
class NotificationTextPlainComponent extends Component {
    static $inject = ['props'];
    constructor(props) {
        super(props);
        this.state = {
            date: this.getDate(props.notification.date),
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.notification.date !== this.props.notification.date) {
            this.setState({ date: this.getDate(this.props.notification.date) });
        }
    }
    getDate(notificationDate) {
        const today = moment().startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS');
        const yesterdayEnd = moment().subtract(1, 'days').endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS');
        const yesterdayStart = moment().subtract(1, 'days').startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS');
        if (notificationDate >= today) {
            return `Hoje - ${moment(notificationDate).format('HH:mm')}`;
        }
        if (notificationDate < yesterdayEnd && notificationDate > yesterdayStart) {
            return `Ontem - ${moment(notificationDate).format('HH:mm')}`;
        }
        return `${moment(notificationDate).format('DD/MM/YYYY')} - ${moment(notificationDate).format('HH:mm')}`;
    }
    render() {
        const { notification } = this.props;
        return (_jsxs("div", { onClick: this.props.onConsume, children: [_jsx("div", { className: `notification-title ${notification.status === 'received' ? 'b' : ''}`, dangerouslySetInnerHTML: { __html: notification.content } }), _jsx("div", { className: "f6 mt3 tr", children: notification.date })] }));
    }
}
export default NotificationTextPlainComponent;
